<div class="container">
    <div class="body-area">
        <div class="tam-form-field post-action">
            <div *ngIf="false">
                <div class="tam-form-label">{{'workflow.post_actions' | stringLiterals}}</div>
                <div class="tam-form-field create-relationship" [ngClass]="{'has-error':!valid}">
                </div>
                <div tid="create_relationships" class="caption">
                    <label tam-checkbox (click)="onCreateRelationship()"
                        [(ngModel)]="otherConfig.checkCreateRelationship">
                        <span>{{'general.create_relationship' | stringLiterals}}</span>
                    </label>
                </div>
                <div class="body"
                    [ngClass]="{'is-not-include-create-relationship':!otherConfig.checkCreateRelationship}">
                    <div class="content">
                        <label class="item">The control of parent entity is&nbsp;</label>
                        <tam-single-select-dropdown-filter [dropdownConfig]="parentEntityControlConfig">
                            <ng-template #customContent>
                                <div class="selected-item">
                                    <a
                                        (click)="onParentEntityControlItemClick($event)">{{parentEntityControlLableName}}</a>
                                </div>
                            </ng-template>
                        </tam-single-select-dropdown-filter>
                    </div>
                    <div class="content">
                        <label class="item">Relationship is&nbsp;</label>
                        <tam-single-select-dropdown-filter [dropdownConfig]="relationshipTypeConfig">
                            <ng-template #customContent>
                                <div class="selected-item">
                                    <a (click)="onRelationshipTypeItemClick($event)">{{relationshipType}}</a>
                                </div>
                            </ng-template>
                        </tam-single-select-dropdown-filter>
                    </div>
                    <div class="content">
                        <label class="item">Child entity is&nbsp;</label>
                        <tam-single-entity-dropdown-filter [config]="childEntityConfig">
                            <ng-template #customContent>
                                <div class="selected-item">
                                    <a (click)="onChildEntityItemClick($event)">{{childEntity}}</a>
                                </div>
                            </ng-template>
                        </tam-single-entity-dropdown-filter>
                    </div>
                    <div class="content-actions" *ngIf="config.taskDefinition.postAction.relationship">
                        <div tid="replace_existing_relationships" class="radio-item">
                            <tam-radio [value]=false [(ngModel)]="config.taskDefinition.postAction.relationship.append"
                                [disabled]="false"></tam-radio>
                            <span class="subject">Replace existing relationships</span>
                        </div>
                        <div tid="append_existing_relationships" class="radio-item">
                            <tam-radio [value]=true [(ngModel)]="config.taskDefinition.postAction.relationship.append"
                                [disabled]="false"></tam-radio>
                            <span class="subject">Append existing relationships</span>
                        </div>
                    </div>
                </div>
                <div class="tam-form-help invalid-msg" *ngIf="!valid">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="create-note">
                    <div class="caption">
                        <label tam-checkbox (click)="onCreateNote()" [disabled]="true">
                            <span>Create Note</span>
                        </label>
                    </div>
                </div>
                <div class="create-entity">
                    <div class="caption">
                        <label tam-checkbox (click)="onCreateEntity()" [disabled]="true">
                            <span>Create Entity</span>
                        </label>
                    </div>
                </div>
                <div class="update-metadata">
                    <div class="caption">
                        <label tam-checkbox (click)="onUpdateMetadata()" [disabled]="true">
                            <span>Update Metadata</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="subscribe-notification">
                <div class="notification-toggle">
                    <span class="tam-form-label">{{'workflow.send_a_notification' | stringLiterals}}</span>
                    <kendo-switch [(ngModel)]="otherConfig.isNotificationOn" (valueChange)="onToggleNotification()">
                    </kendo-switch>
                </div>
                <div class="body" *ngIf="otherConfig.isNotificationOn">
                    <div class="content">
                        <kendo-multiselect #kendom class="tam-dropdown " [data]="filteredEntityItems"
                            [filterable]="true" [(ngModel)]="selectedValues" [autoClose]="true" [textField]="'name'"
                            [valueField]="'id'" [listHeight]="140" [loading]="isListLoading"
                            (valueChange)="onReceiverSelectionChanged($event)" (filterChange)="filterReceivers($event)"
                            (focus)="focusRecieverList()">
                            <ng-template kendoMultiSelectNoDataTemplate>
                                <div class="popup-template-no-data">
                                    <div class="no-data"><span>NO DATA FOUND</span></div>
                                </div>
                            </ng-template>
                        </kendo-multiselect>
                    </div>
                    <div class="content">
                        <label tam-checkbox (click)="onEmailOptionChanged()"
                            [(ngModel)]="config.taskDefinition.postNotification && config.taskDefinition.postNotification.email">
                            <span>Email</span>
                        </label>
                        <label tam-checkbox (click)="onInAppOptionChanged()"
                            [(ngModel)]="config.taskDefinition.postNotification && config.taskDefinition.postNotification.inApp">
                            <span>In-App</span>
                        </label>
                    </div>
                    <div class="tam-form-help"
                        *ngIf="otherConfig.isNotificationOn && (isCheckboxErrorMsgVisible || isEntityErrorMsgVisible)">
                        {{'general.required_error_message' | stringLiterals}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>